import { asOrderTicketId, OrderTicketId } from "@goodfill/domain-properties";
import { CognitoIdToken } from "../users/authTypes";
import { Fetcher } from "../../fetcher";
import { z } from "zod";
import { zodOrderStatuses } from "@goodfill/domain-properties-zod-validators";

export type CustomerRequestOrderFillOrKillInput = { orderId: OrderTicketId };

const schema = z.object({
  orderId: z.string().transform(asOrderTicketId),
  finalStatus: zodOrderStatuses,
  originalStatus: zodOrderStatuses,
});

export type CustomerRequestOrderFillOrKillResult = z.infer<typeof schema>;

export const customerRequestOrderFillOrKill = (
  fetcher: Fetcher,
  data: CustomerRequestOrderFillOrKillInput,
  cognitoIdToken: CognitoIdToken,
) =>
  fetcher({
    endpoint: "/orders/customerRequestOrderFillOrKill",
    method: "POST",
    data,
    cognitoIdToken,
    schema: schema,
  });
